import createModel from "@/__main__/data-model.mjs";
import { paymentMethodModel } from "@/feature-wallet/models/payment-method.mjs";

export const CreatePaymentMethodModel = createModel({
  data: { createPaymentMethod: paymentMethodModel },
}).transform(paymentMethodModel, (data) => data.data.createPaymentMethod);
